import type { IconProps } from "@/types/IconProps";

export function ArrowLeft(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={color}
      className={className}
      width={size}
      height={size}
      {...svgProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m12 19-7-7m0 0 7-7m-7 7h14"
      />
    </svg>
  );
}
